var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4323_33936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.25 20.417L8.83028 16.779C9.71431 15.8807 11.1519 15.8467 12.0773 16.7023L19.25 23.3337",
    stroke: "#0D0D0D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3337 19.8335L23.4066 8.94461C23.4066 8.94461 23.4066 5.8335 21.0003 5.83355H14.851C14.0732 5.83349 12.2457 5.8335 11.2239 5.8335H7.00033C5.71166 5.8335 4.66699 6.87817 4.66699 8.16683V21.0002C4.66699 22.2889 5.71166 23.3335 7.00033 23.3335H21.0003C22.289 23.3335 23.3337 22.2889 23.3337 21.0002V19.8335Z",
    stroke: "#0D0D0D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.91699 12.8335C10.8835 12.8335 11.667 12.05 11.667 11.0835C11.667 10.117 10.8835 9.3335 9.91699 9.3335C8.95049 9.3335 8.16699 10.117 8.16699 11.0835C8.16699 12.05 8.95049 12.8335 9.91699 12.8335Z",
    fill: "#0D0D0D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4323_33936"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0 0.000244141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/imageIcon.9310d8294106625c166d842f66f0438d.svg";
export { ForwardRef as ReactComponent };